import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Breakpoints, BrowserEvents, Classes } from '../global/constants';
import { mediaQueryString } from '../global/helpers';

gsap.registerPlugin(ScrollTrigger);

// ---------- Variables ----------

let animations = { global: [] };
Object.entries(Breakpoints).forEach(([breakpoint, value]) => animations[breakpoint] = { width: value, min: [], max: [] });

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Small Menu----------

	$('.header-menu-fixed').each(function() {

		animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: '#content-wrapper',
					start: '800px top',
					endTrigger: "footer",
					end: 'bottom top',
					// markers: true,
					scrub: true,
					toggleClass: {
						targets: 'body',
						className: "small-menu"
					},
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

		animations.sm.min.push(() => {

			const image = this.querySelector(':scope .section-image');
			const speed = 25;

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				timeline.fromTo(image, { yPercent: -speed }, { yPercent: speed, ease: 'none' });
			}
		});
	});


	// ---------- Parallax 2 images ----------

	$('.content-parallax-two-img-section').each(function() {

		animations.sm.min.push(() => {

			const leftImage = this.querySelector(':scope .left-photo .column-image');

			if(leftImage) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(leftImage, {
					y: () => -120
				}, {
					y: () => this.clientHeight - leftImage.clientHeight - 120
				});
			}

			const rightImage = this.querySelector(':scope .right-photo .column-image');

			if(rightImage) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top 60%',
						end: 'bottom top',
						// markers: true,
						scrub: true,
						invalidateOnRefresh: true,
					},
				});
				timeline.fromTo(rightImage, {
					y: () => 120
				}, {
					y: () =>  this.clientHeight - rightImage.clientHeight - 380
				});

				// timeline.fromTo(rightImage, {
				// 	y: () => (this.classList.contains('content-parallax-two-img-section')) ? +120 : 0
				// }, {
				// 	y: () => (this.classList.contains('content-parallax-two-img-section')) ? this.clientHeight - rightImage.clientHeight - 380 : this.clientHeight - rightImage.clientHeight
				// });
			}
		});
	});


	// ---------- Parallax single image ----------

	$('.simple-text-parallax-section, .text-person-parallax-section').each(function() {

		animations.sm.min.push(() => {

			const image = this.querySelector(':scope .image-column .column-image');

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});
				timeline.fromTo(image, {
					y: () => (this.classList.contains('text-person-parallax-section')) ? 170 : 120
				}, {
					y: () => (this.classList.contains('text-person-parallax-section')) ? this.clientHeight - image.clientHeight - 200 : this.clientHeight - image.clientHeight - 120
				});
			}
		});
	});


	// ---------- Parallax text ----------

	$('.content-parallax-two-img-container, .title-img-text-section').each(function() {

		animations.sm.min.push(() => {

			const firstTitle = this.querySelector(':scope .title-section');

			if(firstTitle) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});
				timeline.fromTo(firstTitle, {
					y: () => 80
				}, {
					y: () => -80
				});
			}
		});
	});


	// ---------- Decorative scroll line ----------

	$('.scroll-line-section').each(function() {

		animations.sm.min.push(() => {

			if(this) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top 90%',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});
				timeline.set(this, {transformOrigin: "top center"})
				timeline.fromTo(this, {
					scaleY: () => "0"
				}, {
					scaleY: () => "1"
				});
			}
		});
	});


	// ---------- Quote Circle ----------

	$('.simple-text-quote-section').each(function() {

		animations.sm.min.push(() => {

			const circle = this.querySelector(':scope .svg-cercle-quotes');

			if(circle) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});
				timeline.fromTo(circle, {
					rotation: () => "-80",
					opacity: 0.1,
				}, {
					rotation: () => "80",
					opacity: 1,
				});
			}
		});
	});


	// ---------- CTA Single Product ----------

	$('.cta-add-to-cart').each(function () {

		animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: 'form.cart',
					start: 'bottom 10%',
					endTrigger: '.other-products-section',
					end: 'top bottom',
					toggleClass: {targets: this, className: "show"},
					// markers: true,
				}
			});
		});

	});

	// ---------- Handle Media Queries ----------

	let filteredAnimations = {};
	let animationsBreakpoints = {};

	Object.entries(animations).forEach(([breakpoint, value]) => {

		if(Array.isArray(value)) {
			filteredAnimations['all'] = animations.global;
		}
		else {
			filteredAnimations[mediaQueryString(value.width)] = (filteredAnimations[mediaQueryString(value.width)]) ? [...filteredAnimations[mediaQueryString(value.width)], ...value.min] : value.min;
			filteredAnimations[mediaQueryString(value.width, false)] = (filteredAnimations[mediaQueryString(value.width, false)]) ? [...filteredAnimations[mediaQueryString(value.width, false)], ...value.max] : value.max;
		}
	});

	Object.entries(filteredAnimations).forEach(([breakpoint, value]) => animationsBreakpoints[breakpoint] = () => value.map(animation => animation()));

	ScrollTrigger.matchMedia(animationsBreakpoints);
};

$Elements.document.on(BrowserEvents.page.enter, () => initScrollAnimations());
